import { isMeaningful } from "@xplus/utils/utils";
import type { ColumnItem, ColumnOption, ColumnItemOption } from "./table";

/** 有 default header footer  几种注册插槽 */
const slotTypes = [
  "default",
  "content",
  "header",
  "title",
  "footer",
  "checkbox",
];
/** 获取插槽 */
export const getSlots = (columns: ColumnItem[]) =>
  columns
    .filter((v) => v.slots)
    .map((v) => v.slots)
    .map((v) => {
      return Object.keys(v as Record<string, string>)
        .map((i) => (slotTypes.includes(i) ? v[i] : null))
        .filter((v) => v);
    })
    .flat();

/**
 * 处理后缀 柯里化 TODO: 根据需求扩展更多
 * @param {String} symbol '后缀的标识'
 */
export const handleSuffix = (symbol: string) => {
  return function ({ cellValue }) {
    return isMeaningful(cellValue) ? `${cellValue}${symbol}` : "";
  };
};
/**
 * 处理前缀 柯里化 TODO: 根据需求扩展更多
 * 如果标识为currencySymbol和确定要格式化金额
 * @param {String} symbol '后缀的标识'
 * @param {String} amount '金额标识'
 */
export const handlePrefix = (symbol: string, amount?: string) => {
  return function ({ cellValue, row }) {
    if (!isMeaningful(cellValue)) return "";
    if (symbol === "currencySymbol" || amount) {
      cellValue = handleAmount(cellValue);
    }
    return `${row[symbol]}${cellValue}`;
  };
};

/** 处理默认值 */
export const handleDefaultShow = () => {
  return function ({ cellValue }) {
    return isMeaningful(cellValue) ? cellValue : "-";
  };
};
/**
 * 处理枚举 柯里化
 * @param {Array} options '枚举的项列表'
 */
export const handleEnum = (options: ColumnOption) => {
  return function ({ cellValue }) {
    if (!isMeaningful(cellValue)) return "-";
    options = typeof options === "function" ? options() : options;
    const element = (options as ColumnItemOption[]).find(
      (v) => v.id === cellValue
    );
    return element ? element.text : cellValue;
  };
};
/**
 * 格式化数据
 *
 * @param { number} num - 要格式化的数据
 * @param { number} digits - 小数点后数字的个数 默认为2
 * @returns number
 */
export const toFixed = (num: number, digits = 2) => {
  if (typeof num === "number" && isNaN(num)) return null;
  return Number.parseFloat(num.toString()).toFixed(digits);
};
// 金额  参数：数值、保留几位小数
export function handleAmount(val: number, num = 2) {
  const result = toFixed(val, num);
  if (!result) {
    return val;
  }
  const thousandResult = amountThousandFormat(result);
  const arr = thousandResult.split(".");
  if (arr.length === 2) {
    return arr[1].length >= 2 ? thousandResult : `${thousandResult}0`;
  } else {
    return `${thousandResult}.00`;
  }
}
// 金额千分位格式化
function amountThousandFormat(num) {
  return num.toString().replace(/\d+/, (n) => {
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => `${$1},`);
  });
}

/** * 处理内容的格式化 */
export const handleFormatter = (columns: ColumnItem[]) => {
  columns.forEach((v) => {
    if (v.suffix) {
      v.formatter = handleSuffix(v.suffix);
    }
    if (v.prefix) {
      v.formatter = handlePrefix(v.prefix);
    }
    // 没有前缀 后缀 插槽 和已有格式化 才取处理默认值
    if (!v.suffix && !v.prefix && !v.slots && !v.formatter && !v.noFormat) {
      v.formatter = handleDefaultShow();
    }
    if (v.options) {
      v.formatter = handleEnum(v.options);
    }
  });
  return columns;
};
